import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { NuqsAdapter } from 'nuqs/adapters/tanstack-router';
import { useDesktopTitleBar } from '~/app/useDesktopTitleBar';
import { Toaster } from '~/components/ui/sonner';
import { TooltipProvider } from '~/components/ui/tooltip';
import { ConfirmProvider } from '~/ui/Confirm';

export interface RouterContext {
  queryClient: QueryClient;
}

// NuqsAdapter lets the data table keep search, filters, sort and page in the URL (useUrlListState).
export const Route = createRootRouteWithContext<RouterContext>()({
  component: Root,
});

function Root() {
  useDesktopTitleBar();
  return (
    <NuqsAdapter>
      {/* One provider: once a tooltip shows, the next one along shows at once (Slack's rail). */}
      <TooltipProvider>
        <ConfirmProvider>
          <Outlet />
        </ConfirmProvider>
      </TooltipProvider>
      <Toaster />
    </NuqsAdapter>
  );
}
